export default "__VITE_ASSET__DNpcfKv___"